import { useEffect, useState } from 'react'
import type { IEliteLoyaltyApiResponse } from '@cleartrip/ct-design-header'

import { getEliteMembershipStatus } from '@/api/homepage/eliteMembershipStatus'

// fetches the elite membership status for the header pill (works logged-in and logged-out)
export const useEliteMembershipStatus = (isSignedIn: boolean) => {
    const [eliteDetails, setEliteDetails] = useState<IEliteLoyaltyApiResponse[] | undefined>(undefined)

    useEffect(() => {
        let active = true
        getEliteMembershipStatus(isSignedIn).then(result => {
            if (active) {
                setEliteDetails(result ?? undefined)
            }
        })
        return () => {
            active = false
        }
    }, [isSignedIn])

    return eliteDetails
}
